import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CountryLink from 'Components/common/CountryLink';
import CountryLinkWrapper from 'Components/common/CountryLinkWrapper';

import RegionLink from 'Components/common/RegionLink';
import SmartText from '@reuters-graphics/react-smart-text';
import Status from '../Headline/Status';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import last from 'lodash/last';

const atlas = new AtlasMetadataClient();

const getCountries = (globalStatistics, countries, country) => {
  const { distributionRanks, latestWeeklyAvgs } = globalStatistics;
  const ranked = countries
    .map(c => c.isoAlpha2)
    .filter(c => c !== country.isoAlpha2)
    .filter(c => c in distributionRanks.cases);
  ranked.sort((a, b) => {
    const aRank = Math.round(distributionRanks.cases[a] * 10);
    const bRank = Math.round(distributionRanks.cases[a] * 10);
    const aAvg = last(latestWeeklyAvgs.cases[a]);
    const bAvg = last(latestWeeklyAvgs.cases[b]);
    if (aRank > bRank) return -1;
    if (aRank < bRank) return 1;
    if (aAvg > bAvg) return -1;
    if (aAvg < bAvg) return 1;
  });
  return ranked.slice(0, 4);
};

const CountryReferral = ({ country, locale, globalStatistics, firstItem }) => (
  <CountryLinkWrapper country={country.slug}>
    <div className='country-row'>
      <div className=''>
        <div className='country-title'>
          {atlas.getCountry(country.isoAlpha2).translations[locale]}
          <span>
            {Math.round(last(globalStatistics.latestWeeklyAvgs.cases[country.isoAlpha2])).toLocaleString(locale)}
            {firstItem ? ' *' : ''}
          </span>
        </div>
        <div className='trend-status'>
          <Status globalStatistics={globalStatistics} activeCountrySlug={country.slug} />
        </div>
      </div>
    </div>
  </CountryLinkWrapper>
);

const LeadingRegion = (props) => {
  const { globalStatistics } = props;
  const countrySlug = useContext(CountryContext);
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext).template.countryReferrals;

  const country = atlas.getCountry(countrySlug);
  const region = atlas.getRegionByCountry(countrySlug);
  const countries = getCountries(globalStatistics, region.countries, country);

  return (
    <div className={classnames(component)}>
      <div className='col-12 col-lg-10 mx-auto px-0'>
        <div className='section-spacer-internal' />
        <div className=''>

          <div className='section-spacer-internal before mx-auto' />
          <div className='link-container'>
            <div className='wrapper'>
              <div className='title'>
                <SmartText
                  source={content.title}
                  context={{
                    region: <RegionLink region={region.slug} key={region.slug} />,
                  }}
                />
              </div>
              {countries.map((c, i) => (
                <CountryReferral
                  country={atlas.getCountry(c)}
                  locale={locale}
                  globalStatistics={globalStatistics}
                  firstItem={i === 0}
                  key={c}
                />
              ))}
            </div>
          </div>
        </div>
        <div className='legend mt-4'>
          <div>
            <p>* {content.legend.note}</p>

          </div>
        </div>
      </div>
      <div className='section-spacer after mx-auto' />
      <div className='section-spacer-internal' />
    </div>
  );
};

export default LeadingRegion;
